import { appConfig } from "App";

export const AuthSrc = (url, noDefalut= false) => {
  if (!url) {
    if(noDefalut){
      return "";
    }else{
      return process.env.PUBLIC_URL + "/artwork.png";
    }
    
  } else if (url.match(/^\s*https?:\/\/.*\?.*Signature=/)) {
    return url;
  } else if (url.includes("PLAYLIST_ARTWORK") || url.includes("ALBUM_CREATE_ARTWORK")) {
    return url.replace(
      /^\s*https?:(\/\/|\\\\)/i,
      `${appConfig.CENTRAL_API}/s3_artwork/`
    );
  } else {
    return url.replace(
      /^\s*https?:(\/\/|\\\\)/i,
      `${appConfig.CENTRAL_API}/artwork/`
    );
  }
};
